<app-portfolio-report-summary
  [details]="details()"
  [hasRoadmap]="hasRoadmap()"
  [hasRoadmapLicence]="hasRoadmapLicence()"
  [portfolioId]="portfolioId()"
  [totals]="totals()"
  [customLogo]="customLogo()"
/>
<ng-content />
